import React from 'react'
import { Tooltip } from '..'
import { primaryTheme, abbreviateMaterialType } from '../../utils/helpers'

/*Card Colors*/
const DragDisabledColor = 'lightgray'
const DefaultColor = primaryTheme
const GuniteFlashColor = 'deeppink'
const PebblePrepColor = '#E6C510'
const PebbleAppColor = '#0E89AD'
const PebbleDetailColor = '#1F8F4E'
const GuniteColor = '#33dfff'
const WarrantyColor = '#BE93D4'
const CrewRepairColor = '#6D41A1'
const PresiteColor = '#EA9C0B'

/*Card Icons*/
const SlurryIndicator = {
    height: 12,
    width: 12,
    backgroundColor: '#FFA500',
    borderRadius: '50%',
    display: 'inline-block',
    margin: '0 2px'
}

const TrashIndicator = {
    height: 12,
    width: 12,
    backgroundColor: '#4682B4',
    borderRadius: '50%',
    display: 'inline-block',
    margin: '0 2px'
}

const PrepCompleteIndicator = {
    height: 12,
    width: 12,
    backgroundColor: '#008000',
    borderRadius: '50%',
    display: 'inline-block',
    margin: '0 2px'
}

const ReadyToApplyIndicator = {
    height: 12,
    width: 12,
    backgroundColor: '#8F3985',
    borderRadius: '50%',
    display: 'inline-block',
    margin: '0 2px'
}

const NegativeOrRolledEdgeSpaIndicator = {
    height: 12,
    width: 12,
    backgroundColor: '#ff00ff',
    borderRadius: '50%',
    display: 'inline-block',
    margin: '0 2px'
}

/*Card Styling*/
const ExpandedCardNotesStyle = {
    fontSize: '8pt',
    whiteSpace: 'pre-line',
    maxHeight: '2.3em',
    overflow: 'auto'
}
const ExpandedCardScrollableColorsStyle = {
    fontSize: '8pt',
    whiteSpace: 'pre-line',
    maxHeight: '2.3em',
    overflow: 'auto'
}

/*Card Functions*/
const GetColorAdditionNodes = (colorAdditions) => {
    const nodecollection = colorAdditions?.length
        ? colorAdditions.map((ca, idx) => {
            const materialAbbr = abbreviateMaterialType(ca?.material_type)

            const color = ca?.color?.name || 'No Color'

            const formattedAdditions = !ca?.additions?.length ? '' : ' : ' + ca.additions.map(a => a.name).join(', ')

            return <p style={{ marginBottom: 1 }} key={`color-${idx}`}>{materialAbbr.concat(' - ', color) + formattedAdditions}</p>
        })
        : null

    return nodecollection
}

const CleanMeasurements = (measurement) => {
    return (measurement === null || measurement.toLowerCase() === 'null') ? '' : measurement
}

const JobOrderColors = ['rgba(154, 99, 36, .35)', 'rgba(245, 130, 49, .35)', 'rgba(255, 225, 25, .35)',
    'rgba(60, 180, 75, .35)', 'rgba(66, 212, 244, .35)', 'rgba(67, 99, 216, .35)', 'rgba(240, 50, 230, .35)', 'rgba(220, 190, 255, .35)']

const FREEFORM_POOLTYPE_ID = 101
const GEOMETRIC_POOLTYPE_ID = 102
const freeformOrGeometricBadgeStyle = {
    color: 'white',
    padding: '3px',
    fontSize: '.9em',
    fontWeight: 'bold',
    textAlign: 'center',
    borderRadius: '50%',
    verticalAlign: 'middle',
    backgroundColor: 'steelblue'
}
const FreeFormOrGeometricBadge = ({ isFreeForm, isGeometric }) => {
    return (!isFreeForm && !isGeometric)
        ? <></>
        : <Tooltip content={isFreeForm ? 'Free Form' : 'Geometric'} >
            <span style={freeformOrGeometricBadgeStyle}>
                {isFreeForm ? 'F' : 'G'}
            </span>
        </Tooltip>
}

const WARRANTY_CATEGORY_ID = 3

const sortCrewRepairCardsToEnd = (a, b) => {
    const aIsCrewRepair = a?.content?.job_category?.id === WARRANTY_CATEGORY_ID
    const bIsCrewRepair = b?.content?.job_category?.id === WARRANTY_CATEGORY_ID
    return aIsCrewRepair && !bIsCrewRepair
        ? 1
        : bIsCrewRepair && !aIsCrewRepair
            ? -1
            : 0
}

export {
    DragDisabledColor, DefaultColor, GuniteFlashColor, PebblePrepColor, PebbleAppColor, CrewRepairColor,
    PebbleDetailColor, GuniteColor, WarrantyColor, PresiteColor, ExpandedCardNotesStyle, SlurryIndicator,
    TrashIndicator, PrepCompleteIndicator, ReadyToApplyIndicator, NegativeOrRolledEdgeSpaIndicator,
    ExpandedCardScrollableColorsStyle, GetColorAdditionNodes, CleanMeasurements, JobOrderColors,
    FREEFORM_POOLTYPE_ID, GEOMETRIC_POOLTYPE_ID, FreeFormOrGeometricBadge, WARRANTY_CATEGORY_ID, sortCrewRepairCardsToEnd
}